const BACKEND_INFINITY = -1;

export class UserPbxPackage {
  constructor(data) {
    this.package_id = data['package_id'] || null;

    this.name = data['name'] || null;
    this.next_payment_at = data['next_payment_at'] || null;

    this.estimate = data['estimate'] === true;
    this.record = data['record'] === true;
    this.ivr_count = data['ivr_count'] || 0;
    this.disk_space_mb = data['disk_space_mb'] || 0;
    this.contact_count = data['contact_count'] || 0;
    this.contact_method_count = data['contact_method_count'] || 0;
    this.sip_account_with_caller_id_count = data['sip_account_with_caller_id_count'] || 0;
  }

  _is_infinity(val) {
    return val === BACKEND_INFINITY;
  }

  _get_frontend_infinity() {
    return Infinity;
  }

  _check_backend_infinity(val) {
    if (this._is_infinity(val)) {
      return this._get_frontend_infinity();
    }

    return val;
  }

  get is_allow_record() {
    return this.record === true;
  }

  get limit_contacts() {
    return this._check_backend_infinity(this.contact_count);
  }

  get limit_contact_methods() {
    return this._check_backend_infinity(this.contact_method_count);
  }
}
